import { createSelector } from 'reselect';

import { RootState } from '../types';

export default class SearchSelectors {
  static selectSearch = (state: RootState) => state.search;

  static getFetching = createSelector([SearchSelectors.selectSearch], (search) => search.isFetching);

  static getError = createSelector([SearchSelectors.selectSearch], (search) => search.error);
}
